/* An object containing a function that takes a parameter of type UserReferenceTypes and returns an array of objects.
*/

import UserReferenceTypes from "src/store/UserReference/types"
import formReggie from "./FormReggie"

const dropDownOptions = {
    getReference: (reference: UserReferenceTypes) => {
        let temp: any = {...reference}//so original ref data stays untouched
        let dropDownReference: any = []
        if (temp) {
            delete temp.allStates
            delete temp.allowedStates
            delete temp.terminationReasons
        }

        for (let key in temp) {
            let values = []
            for(let i = 0; i < temp[key].length; i++){
                values.push(temp[key][i].text)
            }
            dropDownReference.push({
                name: formReggie.titleCase(formReggie.deCamel(key)),
                values: values
            })
        }
        return dropDownReference
    }
}

export default dropDownOptions